import api from '../config/axiosConfig';

const workOrderDetailService = {
  getDetailsByWorkOrder: async (workOrderId) => {
    const response = await api.get(`/work-order-details/work-order/${workOrderId}`);
    return response.data;
  },

  scheduleEntity: async (detailId, scheduleData) => {
    const response = await api.post(`/work-order-details/${detailId}/schedule`, scheduleData);
    return response.data;
  },

  updateDetail: async (detailId, updates) => {
    const response = await api.put(`/work-order-details/${detailId}`, updates);
    return response.data;
  },

  completeDetail: async (detailId, completionNotes) => {
    const response = await api.post(`/work-order-details/${detailId}/complete`, { completionNotes });
    return response.data;
  },

  cancelDetail: async (detailId, reason) => {
    const response = await api.post(`/work-order-details/${detailId}/cancel`, { reason });
    return response.data;
  },

  syncDetails: async (workOrderId) => {
    const response = await api.post(`/work-order-details/work-order/${workOrderId}/sync`);
    return response.data;
  },

  getUserDetails: async (userId, date) => {
    const response = await api.get(`/work-order-details/user/${userId}?date=${date}`);
    return response.data;
  },

  getWorkOrderIdsByUser: async (userId) => {
    const response = await api.get(`/work-order-details/user/${userId}/work-order-ids`);
    return response.data;
  }
};

export default workOrderDetailService;
